import { ExclamationMarkCircleFilled } from "components/icons/generated";
import Timestamp from "components/Timestamp";
import Box from "ds/components/Box";
import Icon from "ds/components/Icon";
import Tooltip from "ds/components/Tooltip";
import Typography from "ds/components/Typography";
import { formatDate } from "utils/date";
import { getNowTimeMs, unixTimestampToMs } from "utils/time";

type ApiKeyExpiresAtProps = {
  expiresAt: number | null;
};

const ApiKeyExpiresAt = ({ expiresAt }: ApiKeyExpiresAtProps) => {
  if (!expiresAt) {
    return (
      <Typography tag="span" variant="p-body3">
        Never expires
      </Typography>
    );
  }

  const isExpired = unixTimestampToMs(expiresAt) <= getNowTimeMs();

  if (isExpired) {
    const formattedDate = formatDate({ date: unixTimestampToMs(expiresAt) });

    return (
      <Tooltip
        on={(props) => (
          <Box {...props} direction="row" gap="small" align="center">
            <Icon src={ExclamationMarkCircleFilled} color="danger" />
            <Typography tag="span" variant="p-body3" color="danger">
              Expired
            </Typography>
          </Box>
        )}
      >
        {`Expired on ${formattedDate}`}
      </Tooltip>
    );
  }

  return <Timestamp variant="p-body3" timestamp={expiresAt} />;
};

export default ApiKeyExpiresAt;
